<template>
  <div v-if="activeTab === name"><slot></slot></div>
</template>
<script>
export default {
  inject: ['activeTab'],
  props: {
    name: { type: String, default: undefined }
  }
}
</script>
